import { Loader2 } from 'lucide-react';
import { cn } from '@/shared/utils/utils';

export function Spinner({ className }: { className?: string }) {
  return <Loader2 className={cn('h-5 w-5 animate-spin text-primary', className)} aria-label="Loading" />;
}
